// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"306":"d1a60d64","319":"1109fc93","826":"1109fc93"}[chunkId] + ".chunk.css";
};